import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import { IRoute } from "src/common/typings/routes";
import { AuthModule } from "./AuthModule";
import { ForgotPassword, LoginPage, RegisterPage } from "./pages";
import { CreatePasswordPage } from "./pages/CreatePasswordPage";
import { SetPasswordPage } from "./pages/SetPasswordPage";

export const AuthRoute: IRoute = {
  title: "Auth Module",
  path: "/auth",
  icon: HomeIcon,
  component: AuthModule,
  subRoutes: [
    { icon: InfoIcon, component: LoginPage, path: "/login", title: "Auth Login" },
    { icon: NewReleasesIcon, component: RegisterPage, path: "/register", title: "Auth Register" },
    { icon: NewReleasesIcon, component: ForgotPassword, path: "/forgot", title: "Forgot Password" },
    {
      icon: NewReleasesIcon,
      component: CreatePasswordPage,
      path: "/create-password",
      title: "Create Password",
    },
    {
      icon: NewReleasesIcon,
      component: SetPasswordPage,
      path: "/set-password",
      title: "set Password",
    },
  ],
};
